const isProduction = process.env.NODE_ENV === 'production';

const REDACT_KEYS = new Set([
  'authorization',
  'token',
  'access_token',
  'password',
  'image_base64',
  'visualization',
  'ocr_data',
  'extracted_data',
  'license_plate',
  'chassis',
  'config',
  'request',
  'response'
]);

const sanitizeArg = (arg, depth = 0) => {
  if (depth > 2) return '[Truncated]';
  if (arg === null || arg === undefined) return arg;
  if (typeof arg === 'string') {
    return arg.length > 300 ? `${arg.slice(0, 300)}...[Truncated]` : arg;
  }
  if (typeof arg !== 'object') return arg;
  if (Array.isArray(arg)) return arg.slice(0, 8).map((item) => sanitizeArg(item, depth + 1));

  const output = {};
  Object.entries(arg).forEach(([key, value]) => {
    if (REDACT_KEYS.has(key.toLowerCase())) {
      output[key] = '[Redacted]';
    } else {
      output[key] = sanitizeArg(value, depth + 1);
    }
  });
  return output;
};

const sanitizeArgs = (args) => args.map((arg) => sanitizeArg(arg));

export const logger = {
  debug: (...args) => {
    if (!isProduction) console.debug(...sanitizeArgs(args));
  },
  info: (...args) => {
    if (!isProduction) console.info(...sanitizeArgs(args));
  },
  warn: (...args) => {
    if (!isProduction) console.warn(...sanitizeArgs(args));
  },
  error: (...args) => {
    if (!isProduction) console.error(...sanitizeArgs(args));
  }
};
